module.exports = __webpack_public_path__ + "static/media/RemoveSelectedCourse_X.ee8302de.svg";